import { connect } from 'react-redux';

import CognitoFormScreen from '../components/CognitoFormScreen';
import { destroySession } from '../../../../../state/actions';

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    destroySession: (cb) => {
      dispatch(destroySession(cb));
    },
  };
};

const CognitoFormScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormScreen);

export default CognitoFormScreenContainer;
